// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

Sentry.init({
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN_CINEMA_WEBSITE,
    environment: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT,

    // CIN-15436: no replay integration here. It is installed by BookingObservability, on booking routes only and
    // after analysis consent, fully masked (this app used to record 1% of every page unmasked and without consent).

    // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
    tracesSampleRate: 0.01,

    // What the lazily installed replay reads: no session recording, an error uploads the buffered replay.
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,

    // Setting this option to true will print useful information to the console while you're setting up Sentry.
    debug: false,

    // Enable sending user PII (Personally Identifiable Information) including IP addresses
    sendDefaultPii: false
});
